import React from "react";
import { BOOKING_URL } from "@/lib/site";
import { BookLink } from "@/components/site/BookLink";
import { useContent } from "@/context/ContentContext";

export function AnnouncementBar() {
  const { announcement } = useContent();
  if (!announcement || announcement.show === false) return null;
  return (
    <div
      data-testid="announcement-bar"
      className="w-full bg-[var(--charcoal)] text-[#F3E9DC] text-center py-2 px-4 text-[0.72rem] tracking-[0.14em] uppercase flex items-center justify-center gap-3 flex-wrap"
    >
      <span className="text-[var(--gold-soft)]">✦</span>
      <span>{announcement.text}</span>
      <BookLink
        label="Announcement Bar"
        href={BOOKING_URL}
        data-testid="announcement-book-btn"
        className="underline underline-offset-4 hover:text-[var(--gold-soft)] transition-colors"
      >
        Book Now
      </BookLink>
    </div>
  );
}
